import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { from } from 'rxjs';
import { AngularFireDatabase, AngularFireObject } from '@angular/fire/database';
import { environment } from 'src/environments/environment';

import { getUserRole, setUserRole, setUser, getUser, removeUser } from 'src/app/utils/util';

import { UserRole } from '../shared/auth.roles';
import { map } from 'rxjs/operators';

const databaseName = environment.databaseName;

export interface ISignInCredentials {
  email: string;
  password: string;
}

export interface ICreateCredentials {
  role: string;
  email: string;
  password: string;
  estado: string;
  displayName: string;
  empresa: string;
  locales: string;
}

export interface IPasswordReset {
  code: string;
  newPassword: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {

  role: any;
  // Usamos el Servicio 'AngularFireObject' de Angular Fire para listar los datos como objeto
  appsRef: AngularFireObject<any>;

  constructor(private auth: AngularFireAuth, private db: AngularFireDatabase) { }

  // tslint:disable-next-line:typedef
  signIn(credentials: ISignInCredentials) {
    return this.auth
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(({ user }) => {
        return user;
      });
  }

  // tslint:disable-next-line:typedef
  signOut() {
    removeUser();
    return from(this.auth.signOut());
  }

  // tslint:disable-next-line:typedef
  register(credentials: ICreateCredentials) {
    return this.auth
      .createUserWithEmailAndPassword(credentials.email, credentials.password)
      .then(async ({ user }) => {
        // await user.updateProfile({
        //   displayName: credentials.displayName
        // });

        await this.auth.signOut()
        //await this.auth.updateCurrentUser(user);
        this.appsRef = this.db.object(databaseName+'/USUARIOS');
        let object = {};
        object[user.uid] = {
          nombre: credentials.displayName,
          rol: credentials.role,
          estado: credentials.estado,
          email: credentials.email,
          empresa:credentials.empresa,
          locales: credentials.locales
        }
        await this.appsRef.update(object)
        return user;
      });
  }

  // tslint:disable-next-line:typedef
  sendPasswordEmail(email) {
    return this.auth.sendPasswordResetEmail(email).then(() => {
      return true;
    });
  }

  // tslint:disable-next-line:typedef
  resetPassword(credentials: IPasswordReset) {
    return this.auth
      .confirmPasswordReset(credentials.code, credentials.newPassword)
      .then((data) => {
        return data;
      });
  }

  getUserdb(id: string) {
    this.appsRef = this.db.object(databaseName+'/USUARIOS/' + id);
    return this.appsRef;
  }

  // tslint:disable-next-line:typedef
  getUser(): Promise<any> {
    return new Promise(async (resolve) => {
      const u = await this.auth.currentUser;
      let user = {};

      if (u !== null) {
        const { uid, displayName, email, photoURL } = u;
        user = { uid, displayName, email, photoURL };

        this.getUserdb(u.uid).valueChanges().subscribe(data => {
          setUserRole(UserRole[data.rol]);
          user["role"] = getUserRole();
          user["rolename"] = data.rol;
          
          if(typeof data.empresa == 'undefined'){
            user["empresa"] = null;
          }else{
            user["empresa"] = data.empresa
          }

          setUser(JSON.stringify(user))
          let gUser = JSON.parse(getUser());
          gUser.role = parseInt(gUser.role);
          resolve(gUser);
        })
      } else {
        let gUser = JSON.parse(getUser());
        if (gUser) {
          let gUser = JSON.parse(getUser());
          gUser.role = parseInt(gUser.role);
          resolve(gUser);
        } else {
          let gUser = {};
          gUser["role"] = null;
          resolve(gUser)
        }
      }
    })
  }
}
